module.exports = __webpack_public_path__ + "img/comparision.f05cd662.svg";